type RouteHandler = (params: Record<string, string>, query: URLSearchParams) => void | Promise<void>;

const routes: { re: RegExp; keys: string[]; handler: RouteHandler }[] = [];

export function route(pattern: string, handler: RouteHandler) {
  const keys: string[] = [];
  const re = new RegExp(
    '^' +
      pattern.replace(/:(\w+)/g, (_, k) => {
        keys.push(k);
        return '([^/]+)';
      }) +
      '$',
  );
  routes.push({ re, keys, handler });
}

export function navigate(hash: string) {
  if (location.hash === hash) dispatch();
  else location.hash = hash;
}

export async function dispatch() {
  const raw = location.hash.replace(/^#/, '') || '/';
  const [path, qs] = raw.split('?');
  const query = new URLSearchParams(qs ?? '');
  for (const r of routes) {
    const m = r.re.exec(path);
    if (m) {
      const params: Record<string, string> = {};
      r.keys.forEach((k, i) => (params[k] = decodeURIComponent(m[i + 1])));
      await r.handler(params, query);
      return;
    }
  }
  navigate('#/');
}

export function startRouter() {
  window.addEventListener('hashchange', () => dispatch());
  dispatch();
}
